import React from 'react'
import { BlockboltLogo } from 'svgIcon'

const ECFooterComponent = () => {
    return (
        <div className="ec-footer-wrapper">
            <BlockboltLogo />
            <p className="subInnerHeadingPara">@2025</p>
        </div>
    )
}

export default ECFooterComponent